import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function FunnelIcon(props) {
  return (
    <SvgIcon {...props}>
      <g transform="matrix(0.01644068,0,0,-0.01644068,2.133178,21.864407)">
        <path d="m 150,1200 h 900 q 21,0 35.5,-14.5 14.5,-14.5 14.5,-35.5 0,-21 -14.5,-35.5 Q 1071,1100 1050,1100 H 150 q -21,0 -35.5,14.5 -14.5,14.5 -14.5,35.5 0,21 14.5,35.5 Q 129,1200 150,1200 Z M 700,500 V 200 L 500,0 v 500 l -350,500 h 900 z" />
      </g>
    </SvgIcon>
  );
}
